import { makeLegendFormatter } from '../utils/legend-formatter.js'
import { dateFormatterInit } from '../utils/date-formatter.js'

const tempHumidityChartOptions = {
  height: 320,
  labels: [
    'Datetime',
    'Temperature',
    'Humidity'
  ],
  series: {
    'Temperature': {
      axis: 'y'
    },
    'Humidity': {
      axis: 'y2'
    }
  },
  axes: {
    x: dateFormatterInit(),
    y: {
      axisLabelWidth: 50,
      independentTicks: true,
      axisLabelFormatter: (y) => y.toFixed(1) + '°C'
    },
    y2: {
      valueRange: [0, 100],
      axisLabelWidth: 50,
      independentTicks: true,
      axisLabelFormatter: (y) => y.toFixed(1) + '%'
    }
  },
  colors: ['#E74C3C', '#3498DB'],
  labelsDiv: 'legendDivTempHumidity',
  labelsSeparateLines: false,
  legend: 'always',
  legendFormatter: makeLegendFormatter((data) => {
    return data
  }),
  animatedZooms: true
}

export {
  tempHumidityChartOptions
}